import { ButtonClass, DialogSize, launchDialog } from "@pjs/core-ui";
import { IAuthorisedDeviceWithState } from "@pjs/user-domain";
import { Immutable } from "@pjs/utilities";
import { userUiI18n } from "../../../i18n/UserUiI18n.const";
import "../styles/authorised-devices-dialog.css";

export const launchConfirmRevokeDeviceDialog = (
    device: Immutable<IAuthorisedDeviceWithState>,
    revokeDeviceAccess: (tokenId: string) => void,
    cachedTrigger: HTMLElement,
    handleFocus: () => void,
    resetIsRevoking: () => void
): void => {
    const dialogTitle = userUiI18n.getString("external_services.authorised_devices.revoke_dialog.title");
    const cancelLabel = userUiI18n.getString("external_services.authorised_devices.revoke_dialog.cancel");
    const revokeLabel = userUiI18n.getString("external_services.authorised_devices.revoke");

    launchDialog<{ htmlContent: string; className?: string }>({
        component: () => import("@pjs/core-ui").then((module) => module.SimpleHtmlDialogContent),
        title: dialogTitle,
        size: DialogSize.Small,
        initialModel: {
            htmlContent: userUiI18n.getString("external_services.authorised_devices.revoke_dialog.content", { device: device.deviceName }),
            className: "uui-authorised-devices-dialog__content"
        },
        dismissAction: (_model, instance) => {
            resetIsRevoking();
            instance.close(() => {
                if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                    cachedTrigger.focus();
                }
            });
        },
        actions: [
            {
                label: cancelLabel,
                ariaLabel: cancelLabel,
                buttonClass: ButtonClass.Outlined,
                dataHook: "revoke-modal-cancel-button",
                disabled: () => false,
                action: (_model, instance) => {
                    resetIsRevoking();
                    instance.close(() => {
                        if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                            cachedTrigger.focus();
                        }
                    });
                }
            },
            {
                label: revokeLabel,
                ariaLabel: revokeLabel,
                buttonClass: ButtonClass.Contained,
                dataHook: "revoke-modal-confirm-button",
                disabled: () => false,
                action: (_model, instance) => {
                    resetIsRevoking();
                    instance.close(() => {
                        if (cachedTrigger !== null && document.body.contains(cachedTrigger)) {
                            cachedTrigger.focus();
                            return;
                        }
                        handleFocus();
                    });
                    revokeDeviceAccess(device.tokenId);
                }
            }
        ]
    });
};
